import { render } from "./TopNavLayout.vue?vue&type=template&id=171f05b5&scoped=true"
import script from "./TopNavLayout.vue?vue&type=script&lang=js"
export * from "./TopNavLayout.vue?vue&type=script&lang=js"

import "./TopNavLayout.vue?vue&type=style&index=0&id=171f05b5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171f05b5"]])

export default __exports__